import type { SelectedDomainInfo } from "./SiteListModal";

// bd-deepcontext-hrq9n — empty defaults for the scheduled-job create form.
// Resetting to this on Create-button click guarantees the form opens blank,
// never carrying over a prior edit/create/cancel's selection (promptIds, name,
// countryCodes, dates, etc.). Kept in its own dependency-light module so it can
// be imported by tests without pulling the component's full transitive graph.
export const EMPTY_FORM_DATA = {
  name: "",
  description: "",
  urlsPerRun: 10,
  // Unified job model (deepcontext-ia8xo.1): a single runs-per-day input,
  // constrained to 1..24, defaulting to 24 (~hourly). No more job type.
  runsPerDay: 24,
  countryCodes: [] as string[],
  promptIds: [] as string[],
  selectedDomainInfos: [] as SelectedDomainInfo[],
  domainExtensions: [] as string[], // TLD filter (e.g., ['sk', 'cz'])
  excludeHomepages: true,
  urlSourceMode: "default" as "default" | "classification",
  countryDistributionMode: "uniform" as "uniform" | "proportional",
  similaritySelectivity: 0,
  startDate: "",
  endDate: "",
  autoSyncManaged: false as boolean, // bd-bqw.1 — auto-sync endDate + isActive from DSP campaigns
  localModelId: null as string | null, // deepcontext-63k8.3 — self-hosted server id; null = Gemini
};

export type ScheduledJobFormData = typeof EMPTY_FORM_DATA;

// bd-deepcontext-1gak — domain-filter fields for the job UPDATE payload.
// Must always send the current array (even empty) so clearing the selection
// actually reaches the backend: ScheduledJobMySQLRepository.update() only
// touches a column when the incoming value is not `undefined`, and maps an
// empty array to NULL. Omitting the field (by sending `undefined` instead of
// `[]`) leaves the previously-saved value untouched.
export function buildDomainFilterUpdateFields(
  formData: Pick<ScheduledJobFormData, "selectedDomainInfos" | "domainExtensions">,
): {
  selectedDomainInfos: SelectedDomainInfo[];
  domainExtensions: string[];
} {
  return {
    selectedDomainInfos: formData.selectedDomainInfos,
    domainExtensions: formData.domainExtensions,
  };
}
